import React from 'react';
import { ICustomizableElement } from '@insurancemenu/imenu-components-lib/dist/types';
import { ActionBarStyled, HeaderSectionStyled } from './styles';

interface Props extends ICustomizableElement {
  children: React.ReactNode;
}

/**
 * Wrapper for filters and actions with vertical borders.
 * Use when filters and actions are needed without a search block or item count.
 */
export const ActionBar: React.FC<Props> = ({ children, className }) => {
  return (
    <ActionBarStyled className={className}>
      <HeaderSectionStyled>{children}</HeaderSectionStyled>
    </ActionBarStyled>
  );
};
